export default __webpack_public_path__ + "static/media/arrow-right.b23842cd.svg";